
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-fashion-jobs",
      function () {
        return require("private-next-pages/international-fashion-jobs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international-fashion-jobs"])
      });
    }
  